var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEuroThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#869898FF",
    d: "M8.73 9c.958-1.813 2.752-3 4.741-3 1.465 0 2.807.632 3.802 1.686a1 1 0 0 0 1.454-1.372C17.387 4.894 15.533 4 13.471 4c-3.179 0-5.827 2.097-6.926 5H5a1 1 0 0 0 0 2h1.058a8.681 8.681 0 0 0 0 2H5a1 1 0 1 0 0 2h1.545c1.099 2.903 3.747 5 6.926 5 2.062 0 3.917-.894 5.256-2.314a1 1 0 0 0-1.454-1.372C16.278 17.368 14.936 18 13.47 18c-1.989 0-3.783-1.187-4.741-3H13a1 1 0 1 0 0-2H8.075a6.815 6.815 0 0 1 0-2H13a1 1 0 1 0 0-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEuroThin);
export default __webpack_public_path__ + "static/media/Ic_euro_thin.c1383fc6f7d3fb8b447fcb33979f3b02.svg";
export { ForwardRef as ReactComponent };